import { LocationUserAdapters } from '../adapters';
import { getUsersByIds } from './GetUsersByIds';

/**
 * One identity for the Location User profile, or `null` when auth-service has
 * no user by that id: the users-by-ids route answers an unknown id with an
 * empty list, not a 404.
 *
 * @param {string} identityId - The auth-service user id
 * @returns {Promise<import('../types/User').ILocationUserProfile | null>}
 */
export const getLocationUser = async (identityId) => {
  const { data } = await getUsersByIds([identityId]);

  return data[0] ? LocationUserAdapters.toLocationUserProfile(data[0]) : null;
};
